import React, { useRef } from "react"
import Modal from "../components/Modal"

interface ModalFieldProps {
  modalOpen: boolean
  onClose: () => void
  shareDate: Date | null
  setShareDate: React.Dispatch<React.SetStateAction<Date | null>>
  handleShareDate: (application: any) => void
  handleCloseModal: () => void
  application: any
}

function toDateInputValue(d: Date | null) {
  if (!d) {
    return ""
  }
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, "0")
  const dd = String(d.getDate()).padStart(2, "0")
  return `${yyyy}-${mm}-${dd}`
}

const EditShareDate: React.FC<ModalFieldProps> = ({
  modalOpen,
  onClose,
  shareDate,
  setShareDate,
  handleShareDate,
  handleCloseModal,
  application,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return modalOpen ? (
    <div className="flex h-full items-center justify-center absolute">
      <Modal
        onClick={onClose}
        classname="fixed inset-0 bg-gray-600 bg-opacity-50 p-3 flex items-center justify-center z-50"
        classname2="relative bg-white rounded-3xl w-auto"
      >
        <div className="bg-white rounded-3xl p-6" onClick={(e) => e.stopPropagation()}>
          <h2 className="text-lg font-semibold mb-4">Paylaşım Tarihini Düzenle</h2>

          <div className="space-y-2">
            <label htmlFor="shareDate" className="text-sm text-neutral-700">
              Paylaşım Tarihi
            </label>

            <div className="relative">
              <input
                ref={inputRef}
                id="shareDate"
                type="date"
                className="
    block w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500
    [appearance:auto]
    [&::-webkit-calendar-picker-indicator]:opacity-100
    [&::-webkit-calendar-picker-indicator]:pointer-events-auto
  "
                value={toDateInputValue(shareDate)}
                onChange={(e) => {
                  const v = e.target.value
                  if (!v) {
                    return setShareDate(null)
                  }
                  const [y, m, d] = v.split("-").map(Number)
                  setShareDate(new Date(y, m - 1, d))
                }}
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 cursor-pointer"
              onClick={handleCloseModal}
            >
              Kapat
            </button>

            <button
              type="button"
              className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-50 cursor-pointer"
              disabled={!shareDate}
              onClick={() => handleShareDate(application)}
            >
              Kaydet
            </button>
          </div>
        </div>
      </Modal>
    </div>
  ) : null
}

export default EditShareDate
